export const SAVE_ENCOUNTER_FORM = 'SAVE_ENCOUNTER_FORM'
export const RESET_ENCOUNTER_FORM = 'RESET_ENCOUNTER_FORM'
export const SAVE_ENCOUNTER_TYPE = 'SAVE_ENCOUNTER_TYPE'
export const RESET_ENCOUNTER_TYPE = 'RESET_ENCOUNTER_TYPE'

export const saveFormState = formState => ({
  type: SAVE_ENCOUNTER_FORM,
  formState
})

export const resetFormState = () => ({
  type: RESET_ENCOUNTER_FORM
})

export const saveEncounterType = encounterType => ({
  type: SAVE_ENCOUNTER_TYPE,
  encounterType
})

export const resetEncounterType = () => ({
  type: RESET_ENCOUNTER_TYPE
})
